// src/components/Apm/ReferenceDataBootstrap.js

import { useSelector } from 'react-redux';

import { useGetCountriesQuery } from '../../redux/features/countryApi';

import { useGetCurrenciesQuery } from '../../redux/features/currencyApi';

const ReferenceDataBootstrap = () => {
  const { isAuthenticated, isAuthLoading } = useSelector((state) => state.authSlice);

  const skip = isAuthLoading || !isAuthenticated;

  useGetCountriesQuery(undefined, {
    skip,
    refetchOnMountOrArgChange: true,
    selectFromResult: () => ({}),
  });

  useGetCurrenciesQuery(undefined, {
    skip,
    refetchOnMountOrArgChange: true,
    selectFromResult: () => ({}),
  });

  return null;
};

export default ReferenceDataBootstrap;
